module.exports = __webpack_public_path__ + "static/media/g3.071877a0.jpg";